import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import isMobileDevice from 'is-mobile';
import { AnchorLogo } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './UnauthorizedPageContainer.module.scss';
const isMobile = isMobileDevice();
export const GetUnauthorizedPageContainerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            UnauthorizedPageContainerTID: {
                BackgroundAnimation: 'unauthorized-page-background-animation',
                Title: 'unauthorized-page-title',
                Subtitle: 'unauthorized-page-subtitle'
            }
        }
    });
export default function UnauthorizedPageContainer(props) {
    const { testId, wideLayout, children, animatedBackground = true, hideBanner = false, otpLayout = false } = props;
    const { t: unauthorizedPageTexts } = useLocaleKeys('auth.screens.unauthorizedPage');
    const { UnauthorizedPageContainerTID } = useMemo(()=>GetUnauthorizedPageContainerTID(), []);
    const mp4Name = isMobile ? 'Anchor_Mobile_Asset.mp4' : 'Anchor_Header.mp4';
    const posterName = isMobile ? '619225327129c80f56875d9f_Anchor_Mobile_Asset.jpg' : '6192253394e4106ddbeb5bdc_Anchor_Web_Asset.jpg';
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.unauthorizedPageContainer, otpLayout && styles.otpLayout),
        "data-testid": testId,
        children: [
            animatedBackground && /*#__PURE__*/ _jsx("video", {
                className: styles.video,
                loop: true,
                muted: true,
                autoPlay: true,
                playsInline: true,
                width: "100%",
                src: "https://mtcdn.co/Anchor/".concat(mp4Name),
                poster: "https://assets.website-files.com/618126a3584667ecd40daf91/".concat(posterName),
                "data-testid": UnauthorizedPageContainerTID.BackgroundAnimation()
            }),
            !hideBanner ? /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsx(AnchorLogo, {
                        className: styles.logo
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": UnauthorizedPageContainerTID.Title(),
                        className: styles.title,
                        children: unauthorizedPageTexts.doBusinessNotBilling()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": UnauthorizedPageContainerTID.Subtitle(),
                        className: styles.subTitle,
                        children: unauthorizedPageTexts.getReadyToPaid()
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: cn(otpLayout && styles.headerSpacer)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.formWrapper, otpLayout && styles.otpLayout),
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.formCard, wideLayout && styles.wide, otpLayout && styles.otpLayout),
                    children: children
                })
            }),
            /*#__PURE__*/ _jsxs("footer", {
                className: styles.footer,
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        className: styles.link,
                        href: "https://www.sayanchor.com/privacy-policy",
                        children: unauthorizedPageTexts.privacyPolicy()
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        className: styles.link,
                        href: "https://www.sayanchor.com/terms-of-contact",
                        children: unauthorizedPageTexts.termsOfService()
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        className: styles.link,
                        href: "https://www.sayanchor.com/data-privacy",
                        children: unauthorizedPageTexts.dataPrivacy()
                    })
                ]
            })
        ]
    });
}
